import React from "react";
import { RiApps2Line } from "@remixicon/react";
import Dropdown from "../../../theme/dropdown/Dropdown";
import Toggle from "../../../theme/toggle/Toggle";
import sectionRegistry from "./sections";
import { useTicketState } from "../../../../contexts/ticket-state";
import Styles from "./TicketDetails.module.scss";

interface TicketSectionPickerProps {
    sections: { sectionId: string; isMinimized: boolean, id: string; }[];
    selectedSet: Set<string>;
    metricPathPrefix: string[];
}

function TicketSectionPicker({ sections, selectedSet, metricPathPrefix }: TicketSectionPickerProps) {
    const settings = useTicketState();

    return (
        <div className={Styles.apps}>
            <Dropdown>
                <Dropdown.Toggle
                    metricPath={[...metricPathPrefix, "show"]}
                    size="small"
                    variant="ghost-gray"
                    prefixIcon={<RiApps2Line />}
                />
                <Dropdown.Menu>
                    <Dropdown.Header>Sections</Dropdown.Header>
                    {sectionRegistry.getAll()
                        .filter(row => row.sectionId)
                        .dedupe(row => row.sectionId)
                        .sortBy("label")
                        .map(section => (
                            <Dropdown.Item
                                prefixIcon={<RiApps2Line />}
                                metricPath={[
                                    ...metricPathPrefix,
                                    "section",
                                    selectedSet.has(section.sectionId) ? "hide" : "show",
                                    section.sectionId]}
                                onClick={() => {
                                    const isSelected = selectedSet.has(section.sectionId);
                                    const newSections = sections.mapFilter(item => (
                                        item.id === section.sectionId && isSelected
                                            ? undefined
                                            : {
                                                sectionId: item.id,
                                                isMinimized: item.isMinimized ?? false,
                                            }));

                                    if (!isSelected) {
                                        newSections.push({
                                            sectionId: section.sectionId,
                                            isMinimized: false,
                                        });
                                    }

                                    settings.userSettings = {
                                        ...settings.userSettings,
                                        chatSections: newSections,
                                    };
                                }}
                            >
                                <div className={Styles["section-picker"]}>
                                    <span>
                                        {section.label}
                                    </span>
                                    <Toggle
                                        size="small"
                                        checked={selectedSet.has(section.sectionId)}
                                    />
                                </div>

                            </Dropdown.Item>
                        ))}

                </Dropdown.Menu>
            </Dropdown>
        </div>
    );
}

export default TicketSectionPicker;
